import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import GlassLoader from "../components/ui/GlassLoader";

function LoginPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [focused, setFocused] = useState(null);
  const [shake, setShake] = useState(false);

  const login = async () => {
    const cleanUsername = username.trim();

    if (!cleanUsername || !password) {
      triggerError("Заполни все поля");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const userRef = doc(db, "users", cleanUsername);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        triggerError("Пользователь не найден");
        return;
      }

      const data = userSnap.data();

      if (data.password !== password) {
        triggerError("Неверный пароль");
        return;
      }

      localStorage.setItem("user", cleanUsername);
      window.dispatchEvent(new Event("authChanged"));
      navigate("/chats");
    } catch (err) {
      console.error(err);
      triggerError("Ошибка входа");
    }
  };

  const triggerError = (msg) => {
    setError(msg);
    setLoading(false);

    setShake(true);
    setTimeout(() => setShake(false), 400);
  };

  if (loading) return <GlassLoader />;

  return (
  <div style={styles.container}>
    {/* 🌫 фон */}
    <div style={styles.bgGlow} />

    {/* 🔥 ЛОГО (БОЛЬШОЕ) */}
    <img src="/logo.png" alt="logo" style={styles.logo} />

{/* 💎 ФОРМА */}
<div
  style={{
    ...styles.card,
    animation: shake ? "shake 0.4s" : "none",
  }}
>
  {/* 🔐 ИНПУТЫ (узкие и по центру) */}
  <div style={styles.inputsWrap}>
    
    <div style={styles.inputGroup}>
      <input
        style={{
          ...styles.input,
          ...(focused === "username" && styles.inputFocus),
        }}
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        onFocus={() => setFocused("username")}
        onBlur={() => setFocused(null)}
      />
      <label
        style={{
          ...styles.label,
          ...(username && styles.labelActive),
        }}
      >
        Логин
      </label>
    </div>

    <div style={styles.inputGroup}>
      <input
        type="password"
        style={{
          ...styles.input,
          ...(focused === "password" && styles.inputFocus),
        }}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onFocus={() => setFocused("password")}
        onBlur={() => setFocused(null)}
      />
      <label
        style={{
          ...styles.label,
          ...(password && styles.labelActive),
        }}
      >
        Пароль
      </label>
    </div>

    {error && <div style={styles.error}>{error}</div>}
  </div>

  {/* 🔘 КНОПКА (шире) */}
  <button
  style={styles.button}
  onClick={login}
  onMouseDown={(e) => {
    e.currentTarget.style.transform = "scale(0.96)";
  }}
  onMouseUp={(e) => {
    e.currentTarget.style.transform = "scale(1)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "scale(1)";
  }}
>
  Войти
</button>

  <p onClick={() => navigate("/register")} style={styles.link}>
    Нет аккаунта? Регистрация
  </p>
</div>

    <style>
      {`
        @keyframes shake {
          0% { transform: translateX(0); }
          25% { transform: translateX(-6px); }
          50% { transform: translateX(6px); }
          75% { transform: translateX(-4px); }
          100% { transform: translateX(0); }
        }

        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-6px); }
          100% { transform: translateY(0px); }
        }
      `}
    </style>
  </div>
);
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "#050505",
    color: "#fff",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",
    overflow: "hidden",
  },

  // 🌫 мягкий свет (ВАУ эффект)
  bgGlow: {
    position: "absolute",
    width: 600,
    height: 600,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.06)",
    filter: "blur(120px)",
    top: "20%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 0,
  },

  // 🔥 ЛОГО (БОЛЬШОЕ И ЖИВОЕ)
  logo: {
    width: 420,              // 💥 ВОТ ТУТ РЕАЛЬНО БОЛЬШЕ
    maxWidth: "90%",
    marginBottom: 30,
    opacity: 0.95,

    animation: "float 4s ease-in-out infinite",

    zIndex: 1,
  },

  // 💎 ФОРМА
  card: {
    width: 360,
    maxWidth: "90%",

    padding: 28,
    borderRadius: 24,

    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(30px)",

    display: "flex",
    flexDirection: "column",
    alignItems: "center", // 🔥 ключ
    gap: 16,

    boxShadow: "0 20px 60px rgba(0,0,0,0.6)",

    zIndex: 1,
  },

 inputGroup: {
  position: "relative",
  width: "100%", // 🔥 обязательно
},

  input: {
  width: "100%",
  padding: "16px 12px 8px",
  borderRadius: 14,
  border: "1px solid rgba(255,255,255,0.1)",
  outline: "none",
  background: "rgba(255,255,255,0.05)",
  color: "#fff",
  fontSize: 15,
  textAlign: "left", // можно center если хочешь iOS-стиль
  transition: "0.25s",
  boxSizing: "border-box",
},

  // ✨ glow
  inputFocus: {
    border: "1px solid rgba(255,255,255,0.3)",
    boxShadow: "0 0 18px rgba(255,255,255,0.12)",
  },

label: {
  position: "absolute",
  left: 14,
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 14,
  color: "rgba(255,255,255,0.5)",
  pointerEvents: "none",
  transition: "0.25s ease",
  background: "transparent",
},

labelActive: {
  top: -18,              // 🔥 выше
  transform: "none",
  fontSize: 11,
  padding: "0 4px",     // немного воздуха
  background: "#2e2e2e", // 👈 чтобы не налезал на border
  borderRadius: 6,
},

button: {
  width: "100%",
  padding: 14,
  borderRadius: 14,

  border: "1px solid rgba(255,255,255,0.25)",

  // 💎 светлее стекло (без glow)
  background: "linear-gradient(180deg, rgba(255,255,255,0.2), rgba(255,255,255,0.08))",
  backdropFilter: "blur(12px)",

  color: "#fff",
  fontWeight: 600,
  fontSize: 15,

  cursor: "pointer",
  transition: "0.15s ease",

  // ❌ убрали glow
  boxShadow: "none",
},

  error: {
    color: "#ff6b6b",
    fontSize: 13,
    textAlign: "center",
  },

  link: {
    textAlign: "center",
    fontSize: 13,
    opacity: 0.6,
    cursor: "pointer",
  },

  form: {
  width: "100%",
  maxWidth: 260, // 🔥 вот это ключ
  margin: "0 auto", // центрирует
  display: "flex",
  flexDirection: "column",
  gap: 16,
},

inputsWrap: {
  width: "100%",
  maxWidth: 260,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  alignItems: "stretch", // важно
},
};

export default LoginPage;